import {Component, OnInit} from '@angular/core';
import {VeiculosService} from "./veiculos.service";
import {VeiculosModel} from "./veiculos.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";

declare let swal: any;

@Component({
  selector: 'app-veiculos-arquivos',
  templateUrl: './veiculos-arquivos.component.html'
})
export class VeiculosArquivosComponent extends Components implements OnInit {

  id_veiculo;
  form: FormGroup;
  arquivo = {"id_veiculo": null, "nome": ""};

  arquivos = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  constructor(
    private veiculosService: VeiculosService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    private route: ActivatedRoute,
    public func: Funcoes,
    private loginService: LoginService,
    formBuilder: FormBuilder,
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'veiculos'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });

    this.form = formBuilder.group({
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      arquivo: []
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;

    let id = this.route.params.subscribe(params => {

      this.id_veiculo = params['id_veiculo'];

      this.getPage(1);
    });




  }

  delete(arquivo) {
    let arquivos = this.arquivos;
    let veiculosService = this.veiculosService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarArquivo')+arquivo.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if(self.global.debug == true){
          console.log(arquivos);
        }

        let index = arquivos.indexOf(arquivo);
        arquivos.splice(index, 1);

        veiculosService.apagarArquivo(arquivo.id_arquivo)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
              self.arquivos = arquivos;
            },
            err => {
              // Revert the view back to its original state
              arquivos.splice(index, 0, arquivo);
              self.arquivos = arquivos;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.veiculosService.getPaginacaoArquivos(pagina, this.itensPorPagina, null, {"id_veiculo": this.id_veiculo})
      .subscribe(data => {
          this.arquivos = data['Payload']['data'];
          this.totalItens = data['Payload']['total'];
          this.carregandoTabela = false;
        },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  uploadArquivoComplete(resp){
    try
    {
      let json = JSON.parse(resp);

      if(!json.Success){
        this.func.alerta(this.func.traduzir('back.erroInterno'), 'erro');
      }else{
        this.func.alerta(this.func.traduzir('front.arquivoEnviadoSucesso'));
        this.arquivo.nome = '';
        this.form.reset();
        this.getPage(1);
      }
    }
    catch(e){}
  }
}



// WEBPACK FOOTER //
// ./src/app/veiculos/veiculos-arquivos.component.ts